import { useLocalStorageState } from './useLocalStorageState';

const STORAGE_KEY = 'matchiGridSeniorOnly';
const DEFAULT_VALUE = false;

export const useSeniorOnly = () => {
	const [seniorOnly, setSeniorOnly] = useLocalStorageState(STORAGE_KEY, DEFAULT_VALUE);
	return { seniorOnly, setSeniorOnly };
};
